import {
  GiftCardAccountBatchSummaryDTO,
  GiftCardBalanceReportResponseType,
} from '../giftcard-service.types';

export const giftCards = {
  giftCards: [
    {
      cardIdentifier: 'ABC016',
      cardAccountBalance: 35.0,
      cardStatus: 'ACTIVE',
      activatedDate: '2024-02-29T07:09:14',
      ownerEmail: '',
      sender: null,
      recipient: null,
      token: null,
    },
    {
      cardIdentifier: null,
      cardAccountBalance: 24.0,
      cardStatus: 'INACTIVE',
      activatedDate: '2024-02-29T07:09:14',
      ownerEmail: '',
      sender: null,
      recipient: {
        name: 'chamali',
        email: 'abcdxxx@gmail.com',
        message: '',
      },
      token: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
    },
    {
      cardIdentifier: 'ABC015',
      cardAccountBalance: 34.0,
      cardStatus: 'ACTIVE',
      activatedDate: '2024-02-29T07:09:14',
      ownerEmail: '',
      sender: null,
      recipient: null,
      token: null,
    },
    {
      cardIdentifier: 'ABC004',
      cardAccountBalance: 23.0,
      cardStatus: 'ACTIVE',
      activatedDate: '2024-02-29T07:09:14',
      ownerEmail: '',
      sender: null,
      recipient: null,
      token: null,
    },
    {
      cardIdentifier: 'ABC014',
      cardAccountBalance: 33.0,
      cardStatus: 'ACTIVE',
      activatedDate: '2024-02-29T07:09:14',
      ownerEmail: '',
      sender: null,
      recipient: null,
      token: null,
    },
    {
      cardIdentifier: 'ABC003',
      cardAccountBalance: 22.0,
      cardStatus: 'ACTIVE',
      activatedDate: '2024-02-29T07:09:14',
      ownerEmail: '',
      sender: null,
      recipient: null,
      token: null,
    },
    {
      cardIdentifier: 'ABC013',
      cardAccountBalance: 32.0,
      cardStatus: 'ACTIVE',
      activatedDate: '2024-02-29T07:09:14',
      ownerEmail: '',
      sender: null,
      recipient: null,
      token: null,
    },
    {
      cardIdentifier: 'ABC002',
      cardAccountBalance: 21.0,
      cardStatus: 'ACTIVE',
      activatedDate: '2024-02-29T07:09:14',
      ownerEmail: '',
      sender: null,
      recipient: null,
      token: null,
    },
    {
      cardIdentifier: 'ABC009',
      cardAccountBalance: 28.0,
      cardStatus: 'ACTIVE',
      activatedDate: '2024-02-29T07:09:14',
      ownerEmail: '',
      sender: null,
      recipient: null,
      token: null,
    },
    {
      cardIdentifier: 'ABC019',
      cardAccountBalance: 38.0,
      cardStatus: 'ACTIVE',
      activatedDate: '-',
      ownerEmail: '',
      sender: null,
      recipient: null,
      token: null,
    },
  ],
  paging: {
    total: 82,
    count: 10,
    totalPages: 9,
    currentPage: 0,
  },
};

export const giftCard = {
  cardIdentifier: '5247832997839723',
  cardAccountBalance: 35.0,
  cardStatus: 'INACTIVE',
  activatedDate: '2024-04-19T17:32:41',
  from: 'prarthana',
  customerList: [
    {
      userId: '8a656f9c-da72-4f89-9acb-57cd18190105',
      email: 'aeturnum.shohan@gmail.com',
      firstName: 'Test user',
      lastName: 'Shona',
      externalId: null,
      accountAliasId: 'aeturnums0513',
    },
  ],
  recipient: {
    name: 'Payments',
    email: 'bounce@simulator.amazonses.com',
    message: '',
  },
  sender: {
    firstName: 'Test Order prarthana',
    lastName: 'Don’t Prepare Receiver',
    email: 'prarthana.s@aeturnum.com',
    phone: '8036190424',
    customerId: 'd9d2a973-8765-4c11-87bd-7cb8f4dbd791',
    adminId: null,
  },
  token: '8ce0d4eb0ad0ac4ea565acd54647962b',
  provider: 'INCENTIVIO_GIFTCARD_SERVICE',
  securityCode: '8831',
};

export const adjustGiftCardBalanceAddValue = {
  transactionType: 'COMP_ADD_VALUE',
  cardIdentifier: 'ABC016',
  cardAccountBalance: 37.0,
  transactionValue: 2.0,
  cardStatus: 'ACTIVE',
  transactionStatus: 'ACCEPT_ADD_VALUE',
  rootErrors: null,
};

export const zeroGiftCardbalance = {
  transactionType: 'RESET_BALANCE',
  cardIdentifier: 'ABC016',
  cardAccountBalance: 0,
  transactionValue: 0,
  cardStatus: 'ACTIVE',
  transactionStatus: 'ACCEPT_RESET_BALANCE',
  rootErrors: null,
};
export const createGiftCard = {
  status: 'ACCEPT_CREATE_CARD',
  cardIdentifier: '5253943786184527',
  code: 200,
  message: 'Successfully created card',
};

export const giftCardTransactions = {
  giftCardTransactionList: [
    {
      amount: '24.00',
      transactionType: 'Imported',
      sourceType: 'Administrator',
      transactionDate: '2024-02-29T12:39:14',
      locationId: null,
      locationName: null,
      adminId: '5b3a4b2f-15e9-493a-8300-700d43d27290',
      adminName: 'Shohan Test Fernando',
      transactionInstant: '2024-02-29T07:09:14.844Z',
      status: 'SUCCESS',
    },
    {
      amount: '2.00',
      transactionType: null,
      sourceType: null,
      transactionDate: '2024-05-02T12:24:49',
      locationId: '040b41cb-cf0e-4f24-9f85-60527cd5122b',
      locationName: '(Only to test TOAST -Apple-Pay) AET Rush Store QE',
      adminId: '9cebee1f-df3a-46e4-9a73-3de5587b675a',
      adminName: null,
      transactionInstant: '-',
      status: 'SUCCESS',
    },
    {
      amount: 'N/A',
      transactionType: 'Card Activation',
      sourceType: 'Administrator',
      transactionDate: '2024-05-02T12:25:10',
      locationId: null,
      locationName: null,
      adminId: '9cebee1f-df3a-46e4-9a73-3de5587b675a',
      adminName: 'Deluxan M',
      transactionInstant: '2024-05-02T06:55:10.090Z',
      status: 'ERROR',
    },
    {
      amount: 'N/A',
      transactionType: 'Card Deactivation',
      sourceType: 'Administrator',
      transactionDate: '2024-05-02T12:25:23',
      locationId: null,
      locationName: null,
      adminId: '9cebee1f-df3a-46e4-9a73-3de5587b675a',
      adminName: 'Deluxan M',
      transactionInstant: '2024-05-02T06:55:23.890Z',
      status: 'SUCCESS',
    },
    {
      amount: 'N/A',
      transactionType: 'Card Activation',
      sourceType: 'Administrator',
      transactionDate: '2024-05-02T12:25:36',
      locationId: null,
      locationName: null,
      adminId: '9cebee1f-df3a-46e4-9a73-3de5587b675a',
      adminName: 'Deluxan M',
      transactionInstant: '2024-05-02T06:55:36.796Z',
      status: 'SUCCESS',
    },
  ],
  paging: {
    total: 5,
    count: 10,
    totalPages: 1,
    currentPage: 0,
  },
};

export const giftCardBalanceReportResponse: GiftCardBalanceReportResponseType =
  {
    status: 'IN_PROGRESS',
    message:
      'Your report is being generated. Once complete, you will get an email. Make sure to check your spam.',
    csvContent: null,
  };

export const giftCardEvents = {
  events: [
    {
      id: '668630c63f389962bafa0d83',
      cardIdentifier: '8018525491684689897',
      eventName: 'GIFT_CARD_CREATED',
      traceId: '223b08f0d3b6cd1e',
      transactionId: '668630c53f389962bafa0d81',
      eventTime: '2024-07-04T05:19:02.686Z',
      description: '',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      extendedAttributes: {
        From: 'IncPayments <IncPayments@incentiviodev.com>',
        To: 'gagana.w@incentivio.com',
        EMAIL_EVENT:
          '{"eventType":"Send","mail":{"timestamp":"2024-07-25T14:38:35.111Z","messageId":"01000190ea545a67-7657536f-1cd8-4bbc-9911-1de007cf9670-000000","source":"IncPayments <IncPayments@incentiviodev.com>","sourceArn":"arn:aws:ses:us-east-1:593489907856:identity/incentiviodev.com","sendingAccountId":"593489907856","destination":["gagana.w@incentivio.com"],"headersTruncated":false,"headers":[{"name":"Date","value":"Thu, 25 Jul 2024 14:38:35 +0000 (UTC)"},{"name":"From","value":"IncPayments <IncPayments@incentiviodev.com>"},{"name":"To","value":"gagana.w@incentivio.com"},{"name":"Message-ID","value":"<836592932.41.1721918315057@ip-172-16-3-187.ec2.internal>"},{"name":"Subject","value":"You Have Received a Gift Card!"},{"name":"MIME-Version","value":"1.0"},{"name":"Content-Type","value":"multipart/mixed;  boundary=\\"----=_Part_40_1282146269.1721918315053\\""},{"name":"X-SES-MESSAGE-TAGS","value":"INC-EMAIL-GROUP=GIFT_CARD, INC-CLIENT-ID=d2776d2a-33ae-4f3b-8091-34cad2e69fdc, INC-GIFTCARD-TOKEN=bf224d2ea7380fd4b3d871482ecc4979, INC_EVENT_TYPE=EMAIL_GIFTCARD_PURCHASE"},{"name":"X-SES-CONFIGURATION-SET","value":"inc-ses-events-handler-dev"}],"commonHeaders":{"from":["IncPayments <IncPayments@incentiviodev.com>"],"to":["gagana.w@incentivio.com"],"messageId":"01000190ea545a67-7657536f-1cd8-4bbc-9911-1de007cf9670-000000","subject":"You Have Received a Gift Card!"},"tags":{"INC_EVENT_TYPE":["EMAIL_GIFTCARD_PURCHASE"],"ses:source-tls-version":["TLSv1.3"],"INC-EMAIL-GROUP":["GIFT_CARD"],"ses:operation":["SendRawEmail"],"ses:configuration-set":["inc-ses-events-handler-dev"],"INC-CLIENT-ID":["d2776d2a-33ae-4f3b-8091-34cad2e69fdc"],"ses:source-ip":["184.73.186.181"],"ses:from-domain":["incentiviodev.com"],"ses:caller-identity":["IAM-EC2-ROLE-POLICY"],"INC-GIFTCARD-TOKEN":["bf224d2ea7380fd4b3d871482ecc4979"]}},"bounce":null,"complaint":null,"delivery":null,"send":{"empty":"AWS doesn\'t include any data for this event. This text is hardcoded in by me (Bob)"},"reject":null,"open":null,"click":null,"failure":null,"eventTime":"2024-07-25T14:38:46.454819Z"}',
        EMAIL_GROUP: 'GIFT_CARD',
      },
      externalStatuses: {},
      additionalDetails: null,
    },
  ],
  paging: {
    total: 1,
    count: 300,
    totalPages: 1,
    currentPage: 0,
  },
  status: 'RETRIEVED_EVENTS',
};

export const giftCardImports: {
  [key: string]: GiftCardAccountBatchSummaryDTO;
} = {};

export const baseGiftCardImport: GiftCardAccountBatchSummaryDTO = {
  id: '',
  sourceType: 'ADMIN_PORTAL',
  clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
  userId: 'userId',
  processedCardCount: 100,
  processedCardList: [],
  successCardCount: 100,
  successCardList: [],
  failedCardCount: 0,
  failedCardList: [],
  type: 'IMPORT_CARD',
  status: 'SUCCESS',
  reportLink:
    'https://d1qyexwopp1853.cloudfront.net/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/20250829083028750/md/French%20Onion.jpg',
  traceId: 'traceId',
  createdDate: '2024-07-01T12:00:00Z',
  updatedDate: '2024-07-01T12:00:00Z',
  userName: 'bobm@incentivio.com',
  closed: false,
};

giftCardImports['1'] = {
  ...baseGiftCardImport,
  id: '1',
  type: 'IMPORT_CARD',
  status: 'SUCCESS',
  closed: true,
  childBatchIds: ['4', '6'],
  childBatches: [],
};

giftCardImports['2'] = {
  ...baseGiftCardImport,
  id: '2',
  status: 'FAILED',
};

giftCardImports['3'] = {
  ...baseGiftCardImport,
  id: '3',
  status: 'PARTIAL_SUCCESS',
  closed: false,
  childBatchIds: ['5', '9'],
  childBatches: [],
};

giftCardImports['4'] = {
  ...baseGiftCardImport,
  id: '4',
  status: 'SUCCESS',
  type: 'REMOVE_CARD',
  parentBatchId: '1',
};

giftCardImports['5'] = {
  ...baseGiftCardImport,
  id: '5',
  status: 'FAILED',
  type: 'REMOVE_CARD',
  parentBatchId: '3',
};

giftCardImports['6'] = {
  ...baseGiftCardImport,
  id: '6',
  status: 'PARTIAL_SUCCESS',
  type: 'REMOVE_CARD',
  parentBatchId: '1',
};

giftCardImports['7'] = {
  ...baseGiftCardImport,
  id: '7',
  status: 'SUCCESS',
  type: 'IMPORT_CARD',
};

giftCardImports['8'] = {
  ...baseGiftCardImport,
  id: '8',
  status: 'IN_PROGRESS',
  type: 'IMPORT_CARD',
};

giftCardImports['9'] = {
  ...baseGiftCardImport,
  id: '9',
  status: 'IN_PROGRESS',
  type: 'REMOVE_CARD',
  parentBatchId: '3',
};

giftCardImports['10'] = {
  ...baseGiftCardImport,
  id: '10',
  status: 'SUCCESS',
  type: 'IMPORT_CARD',
  closed: false,
  childBatchIds: ['11', '12'],
  childBatches: [],
};

giftCardImports['11'] = {
  ...baseGiftCardImport,
  id: '11',
  status: 'FAILED',
  type: 'REMOVE_CARD',
  parentBatchId: '10',
};

giftCardImports['12'] = {
  ...baseGiftCardImport,
  id: '12',
  status: 'FAILED',
  type: 'REMOVE_CARD',
  parentBatchId: '10',
};
